const form = (state = "register", action) => {
    switch (action.type) {
        case "GET_FORM":
            return action.payload
        default:
            return state
    }
}

export default form;